import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, MenuItem, Button, IconButton
} from '@mui/material';
import { motion } from 'framer-motion';
import CloseIcon from '@mui/icons-material/Close';

const TopicModal = ({
    open,
    onClose,
    newTopic,
    setNewTopic,
    exams,
    filteredSubjects,
    handleAddTopic
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle
                sx={{
                    m: 0, p: 2, display: 'flex',
                    justifyContent: 'space-between', alignItems: 'center'
                }}
            >
                <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                    style={{
                        fontWeight: 'bold', fontSize: '1.4rem', color: '#1976d2',
                        display: 'flex', gap: '8px', alignItems: 'center'
                    }}
                >
                    📖 Add New Topic
                </motion.div>

                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: 'absolute', top: 8, right: 8, color: 'red' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {/* Exam Dropdown */}
                <TextField
                    select
                    fullWidth
                    label="Exam"
                    name="exam_id"
                    value={newTopic.exam_id}
                    onChange={(e) => setNewTopic({ ...newTopic, exam_id: parseInt(e.target.value) })}
                    margin="dense"
                >
                    {exams.map((exam) => (
                        <MenuItem key={exam.id} value={exam.id}>
                            {exam.title}
                        </MenuItem>
                    ))}
                </TextField>

                {/* Subject Dropdown */}
                <TextField
                    select
                    fullWidth
                    label="Subject"
                    name="subject_id"
                    value={newTopic.subject_id}
                    onChange={(e) => setNewTopic({ ...newTopic, subject_id: parseInt(e.target.value) })}
                    margin="dense"
                >
                    {filteredSubjects.map((subject) => (
                        <MenuItem key={subject.id} value={subject.id}>
                            {subject.name}
                        </MenuItem>
                    ))}
                </TextField>

                {/* Topic field */}
                <TextField
                    fullWidth
                    label="Topic Title"
                    name="title"
                    value={newTopic.title}
                    onChange={(e) => setNewTopic({ ...newTopic, title: e.target.value })}
                    margin="dense"
                />

                {/* Status */}
                <TextField
                    select
                    fullWidth
                    label="Status"
                    margin="dense"
                    value={newTopic.status}
                    onChange={(e) => setNewTopic({ ...newTopic, status: parseInt(e.target.value) })}
                >
                    <MenuItem value={1}>Active</MenuItem>
                    <MenuItem value={0}>Inactive</MenuItem>
                </TextField>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" color="success" onClick={handleAddTopic}>
                    Add Topic
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TopicModal;
